import React from 'react';

// The component is renamed to DateTimePicker to better reflect its function.
function DateTimePicker(props) {
  const { setFilter, filter } = props;

  // This function updates the 'fromDate' in the filter state.
  const fromDateTimeChange = (dateTime) => {
    setFilter(prevFilter => ({
      ...prevFilter,
      fromDate: dateTime,
    }));
  }

  // This function updates the 'toDate' in the filter state.
  const toDateTimeChange = (dateTime) => {
    setFilter(prevFilter => ({
      ...prevFilter,
      toDate: dateTime,
    }));
  }

  return (
    // I've added some basic styling and labels for better user experience.
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px' }}>
      <label htmlFor="fromDate" style={{ marginRight: '5px' }}>From:</label>
      <input
        // This is the key change: 'datetime-local' provides a UI for date and time.
        type="datetime-local"
        name="fromDate"
        id="fromDate"
        className="form-control date"
        // The value from your filter state is already in the correct format.
        value={filter.fromDate}
        onChange={(e) => fromDateTimeChange(e.target.value)}
      />

      <label htmlFor="toDate" style={{ marginLeft: '10px', marginRight: '5px' }}>To:</label>
      <input
        // This input is also changed to 'datetime-local'.
        type="datetime-local"
        name="toDate"
        id="toDate"
        className="form-control date"
        value={filter.toDate}
        onChange={(e) => toDateTimeChange(e.target.value)}
      />
    </div>
  );
}

// The export is updated to match the new component name.
export default DateTimePicker;